import React, { useState, useEffect } from "react";
import { 
    Card, Row, Col, Button, Badge, Table, Spinner, Alert,
    ListGroup, ProgressBar, Modal
} from "react-bootstrap";
import { useParams, useNavigate, Link } from "react-router-dom";
import { formatCurrency, formatDate } from "../utils/formatters";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

export default function DetailFournisseur() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [fournisseur, setFournisseur] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        fetchFournisseur();
    }, [id]);





    const handleDelete = async () => {
    setIsDeleting(true);
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            `https://sawd.julesferry-ga.com/api/fournisseurs.php?id=${fournisseur.id_fournisseur}`,
            {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            }
        );
        
        const result = await response.json();
        
        if (result.success) {
            setShowDeleteModal(false);
            // Afficher un message de succès (vous pouvez ajouter un système d'alertes)
            navigate('/achats/fournisseurs');
        } else {
            alert(result.message || "Erreur lors de la suppression");
            setShowDeleteModal(false);
        }
    } catch (err) {
        alert("Erreur de connexion au serveur");
        setShowDeleteModal(false);
    } finally {
        setIsDeleting(false);
    }
};


    const fetchFournisseur = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/fournisseurs.php?id=${id}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            
            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setFournisseur(result.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

   const getNoteStars = (note) => {
    // Convertir en nombre et arrondir, avec fallback à 0
    const noteValue = note ? Math.round(parseFloat(note)) : 0;
    
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
            <i key={i} className={`ri-star-${i <= noteValue ? 'fill' : 'line'} text-warning`} style={{ fontSize: '1.2rem' }}></i>
        );
    }
    return stars;
};

    const getStatutBadge = (statut) => {
        const configs = {
            recue_complete: { color: 'success', label: 'Reçue complète', icon: 'ri-check-double-line' },
            recue_partielle: { color: 'warning', label: 'Reçue partielle', icon: 'ri-stack-line' },
            brouillon: { color: 'secondary', label: 'Brouillon', icon: 'ri-draft-line' },
            envoyee: { color: 'info', label: 'Envoyée', icon: 'ri-send-plane-line' },
            annulee: { color: 'danger', label: 'Annulée', icon: 'ri-close-circle-line' }
        };
        const config = configs[statut] || { color: 'secondary', label: statut, icon: 'ri-question-line' };
        
        return (
            <Badge 
                bg={config.color} 
                className="px-3 py-2 rounded-pill"
                style={{
                    background: `linear-gradient(135deg, var(--bs-${config.color}), var(--bs-${config.color}-dark))`,
                    border: 'none',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
            >
                <i className={`${config.icon} me-1`}></i>
                {config.label}
            </Badge>
        );
    };

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" className="mb-3" style={{ width: '3rem', height: '3rem' }} />
                            <p className="text-muted">Chargement des informations du fournisseur...</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error || !fournisseur) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <Alert variant="danger" className="text-center py-5">
                        <i className="ri-error-warning-line fs-48 mb-3 d-block"></i>
                        <h4>{error || "Fournisseur non trouvé"}</h4>
                        <Button variant="outline-danger" className="mt-3" onClick={() => navigate('/achats/fournisseurs')}>
                            <i className="ri-arrow-left-line me-2"></i>Retour à la liste
                        </Button>
                    </Alert>
                </div>
            </>
        );
    }

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    {/* Fil d'Ariane */}
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <Button 
                                    variant="link" 
                                    className="p-0 text-muted" 
                                    onClick={() => navigate('/achats/fournisseurs')}
                                >
                                    <i className="ri-arrow-left-line me-1"></i>Fournisseurs
                                </Button>
                                <span className="text-muted">/</span>
                                <span className="text-primary">Fiche fournisseur</span>
                            </div>
                        </Col>
                    </Row>

                    {/* En-tête avec carte profil */}
                    <Row className="mb-4">
                        <Col md={12}>
                            <Card className="border-0 shadow-sm overflow-hidden">
                                <div className="bg-gradient-primary" style={{ 
                                    height: '120px', 
                                    background: '#ededed',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '-20px',
                                        right: '20px',
                                        width: '200px',
                                        height: '200px',
                                        background: 'rgba(255, 255, 255, 0.1)',
                                        borderRadius: '50%',
                                        pointerEvents: 'none'
                                    }}></div>
                                    <div style={{
                                        position: 'absolute',
                                        bottom: '-30px',
                                        left: '50%',
                                        width: '150px',
                                        height: '150px',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        borderRadius: '50%',
                                        pointerEvents: 'none'
                                    }}></div>
                                </div>
                                <Card.Body className="position-relative" style={{ marginTop: '-60px' }}>
                                    <Row>
                                        <Col md={8}>
                                            <div className="d-flex align-items-end gap-4">
                                                <div className="bg-white rounded-4 shadow-lg p-2" style={{
                                                    boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)'
                                                }}>
                                                    <div className="bg-light rounded-3 d-flex align-items-center justify-content-center" style={{ 
                                                        width: '100px', 
                                                        height: '100px',
                                                        background: 'linear-gradient(135deg, #f8f9fa, #e9ecef)'
                                                    }}>
                                                        <i className="ri-truck-line" style={{ fontSize: '48px', color: '#4361ee' }}></i>
                                                    </div>
                                                </div>
                                                <div className="mb-2">
                                                    <h1 className="display-6 fw-bold mb-1" style={{ color: '#1e293b' }}>
                                                        {fournisseur.raison_sociale}
                                                    </h1>
                                                    <div className="d-flex align-items-center gap-3 flex-wrap">
                                                        <Badge 
                                                            bg="primary" 
                                                            className="px-3 py-2 rounded-pill"
                                                            style={{
                                                                background: 'linear-gradient(135deg, #4361ee, #3a56d4)',
                                                                border: 'none'
                                                            }}
                                                        >
                                                            <i className="ri-barcode-line me-1"></i>
                                                            Code: {fournisseur.code_fournisseur}
                                                        </Badge>
                                                        <span className="text-muted">
                                                            <i className="ri-calendar-line me-1"></i>
                                                            Fournisseur depuis {formatDate(fournisseur.date_creation)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-flex justify-content-end gap-2 mt-3 mt-md-0">
                                                <Button  
                                                    variant="outline-primary" 
                                                    onClick={() => navigate('/achats/commandesNouveau')}
                                                    className="rounded-pill px-4"
                                                >
                                                    <i className="ri-add-line me-2"></i>
                                                    commande
                                                </Button>
                                                <Button 
                                                    variant="primary"
                                                    as={Link}
                                                    to={`/achats/fournisseurs/modifier/${fournisseur.id_fournisseur}`}
                                                    className="rounded-pill px-4"
                                                    style={{
                                                        background: 'linear-gradient(135deg, #4361ee, #3a56d4)',
                                                        border: 'none'
                                                    }}
                                                >
                                                    <i className="ri-pencil-line me-2"></i>
                                                    Modifier
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Cartes KPI */}
                    <Row className="g-3 mb-4">
                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100" style={{
                                borderRadius: '16px',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.1)';
                            }}>
                                <Card.Body className="p-3">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-primary bg-opacity-10 p-3 rounded-3 me-3">
                                            <i className="ri-shopping-bag-line text-primary fs-4"></i>
                                        </div>
                                        <div>
                                            <small className="text-muted d-block text-uppercase fw-semibold tracking-wide">
                                                Total achats
                                            </small>
                                            <h3 className="mb-0 fw-bold text-primary">{formatCurrency(fournisseur.total_achats || 0)}</h3>
                                            <small className="text-muted">
                                                <i className="ri-stack-line me-1"></i>
                                                {fournisseur.nb_commandes || 0} commandes
                                            </small>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="border-0 shadow-sm h-100" style={{
                                borderRadius: '16px',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.1)';
                            }}>
                                <Card.Body className="p-3">
                                    <div className="d-flex align-items-center">
                                        <div className="bg-success bg-opacity-10 p-3 rounded-3 me-3">
                                            <i className="ri-calendar-check-line text-success fs-4"></i>
                                        </div>
                                        <div>
                                            <small className="text-muted d-block text-uppercase fw-semibold tracking-wide">
                                                Dernière commande
                                            </small>
                                            <h5 className="mb-0 fw-bold">
                                                {fournisseur.derniere_commande ? formatDate(fournisseur.derniere_commande) : 'Jamais'}
                                            </h5>
                                            <small className="text-muted">
                                                {fournisseur.derniere_commande ? 
                                                    `${Math.round((new Date() - new Date(fournisseur.derniere_commande)) / (1000 * 60 * 60 * 24))} jours` : 
                                                    '-'}
                                            </small>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                       <Col md={4}>
    <Card className="border-0 shadow-sm h-100" style={{
        borderRadius: '16px',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        cursor: 'pointer'
    }}
    onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0,0,0,0.1)';
    }}
    onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0,0,0,0.1)';
    }}>
        <Card.Body className="p-3">
            <div className="d-flex align-items-center">
                <div className="bg-warning bg-opacity-10 p-3 rounded-3 me-3">
                    <i className="ri-star-line text-warning fs-4"></i>
                </div>
                <div>
                    <small className="text-muted d-block text-uppercase fw-semibold tracking-wide">
                        Note moyenne
                    </small>
                    <div className="d-flex align-items-baseline gap-2">
                        <h2 className="mb-0 fw-bold text-warning">
                            {fournisseur.note_moyenne ? parseFloat(fournisseur.note_moyenne).toFixed(1) : 'N/A'}
                        </h2>
                        <small className="text-muted">/5</small>
                    </div>
                    <div className="mt-1">
                        {getNoteStars(fournisseur.note_moyenne ? Math.round(parseFloat(fournisseur.note_moyenne)) : 0)}
                    </div>
                </div>
            </div>
        </Card.Body>
    </Card>
</Col>
                    </Row>

                    {/* Informations détaillées */}
                    <Row className="g-4 mb-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '16px' }}>
                                <Card.Header className="bg-white border-0 pt-4">
                                    <h5 className="mb-0">
                                        <i className="ri-contacts-line me-2 text-primary"></i>
                                        Coordonnées
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <ListGroup variant="flush" className="bg-transparent">
                                        <ListGroup.Item className="px-0 d-flex justify-content-between align-items-center">
                                            <span className="text-muted">
                                                <i className="ri-phone-line me-2"></i>
                                                Téléphone
                                            </span>
                                            <span className="fw-semibold">{fournisseur.telephone || 'Non renseigné'}</span>
                                        </ListGroup.Item>
                                        <ListGroup.Item className="px-0 d-flex justify-content-between align-items-center">
                                            <span className="text-muted">
                                                <i className="ri-mail-line me-2"></i>
                                                Email
                                            </span>
                                            <span className="fw-semibold">{fournisseur.email || 'Non renseigné'}</span>
                                        </ListGroup.Item>
                                        <ListGroup.Item className="px-0 d-flex justify-content-between align-items-center">
                                            <span className="text-muted">
                                                <i className="ri-map-pin-line me-2"></i>
                                                Adresse
                                            </span>
                                            <span className="fw-semibold text-end">{fournisseur.adresse || 'Non renseignée'}</span>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '16px' }}>
                                <Card.Header className="bg-white border-0 pt-4">
                                    <h5 className="mb-0">
                                        <i className="ri-briefcase-line me-2 text-primary"></i>
                                        Identifiants juridiques
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col md={6}>
                                            <ListGroup variant="flush" className="bg-transparent">
                                                <ListGroup.Item className="px-0 d-flex justify-content-between">
                                                    <span className="text-muted">ICE</span>
                                                    <span className="fw-semibold">{fournisseur.ice || '-'}</span>
                                                </ListGroup.Item>
                                                <ListGroup.Item className="px-0 d-flex justify-content-between">
                                                    <span className="text-muted">Patente</span>
                                                    <span className="fw-semibold">{fournisseur.patente || '-'}</span>
                                                </ListGroup.Item>
                                                <ListGroup.Item className="px-0 d-flex justify-content-between">
                                                    <span className="text-muted">RC</span>
                                                    <span className="fw-semibold">{fournisseur.rc || '-'}</span>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </Col>
                                        <Col md={6}>
                                            <ListGroup variant="flush" className="bg-transparent">
                                                <ListGroup.Item className="px-0 d-flex justify-content-between">
                                                    <span className="text-muted">IF</span>
                                                    <span className="fw-semibold">{fournisseur.identifiant_fiscal || '-'}</span>
                                                </ListGroup.Item>
                                                <ListGroup.Item className="px-0 d-flex justify-content-between">
                                                    <span className="text-muted">CNSS</span>
                                                    <span className="fw-semibold">{fournisseur.cnss || '-'}</span>
                                                </ListGroup.Item>
                                            </ListGroup>
                                        </Col>
                                    </Row>
                                    {fournisseur.conditions_reglement && (
                                        <div className="mt-3 p-3 bg-light rounded-3">
                                            <small className="text-muted d-block mb-2">
                                                <i className="ri-file-text-line me-1"></i>
                                                Conditions de règlement
                                            </small>
                                            <p className="mb-0 small">{fournisseur.conditions_reglement}</p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Dernières commandes */}
                    {fournisseur.commandes?.length > 0 && (
                        <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                            <Card.Header className="bg-white border-0 pt-4 d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">
                                    <i className="ri-file-list-line me-2 text-primary"></i>
                                    Dernières commandes
                                </h5>
                                <Button 
                                    variant="outline-primary" 
                                    size="sm"
                                    className="rounded-pill px-3"
                                    onClick={() => navigate('/achats/commandes')}
                                >
                                    <i className="ri-eye-line me-1"></i>
                                    Voir tout
                                </Button>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <Table hover className="mb-0 align-middle">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>N° Commande</th>
                                                <th>Date</th>
                                                <th className="text-end">Montant</th>
                                                <th>Statut</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fournisseur.commandes.map((cmd, index) => (
                                                <tr key={cmd.id_commande_fournisseur} style={{
                                                    animation: `slideIn 0.3s ease ${index * 0.1}s both`
                                                }}>
                                                    <td>
                                                        <Link to={`/achats/commandes/${cmd.id_commande_fournisseur}`} className="text-primary fw-semibold">
                                                            {cmd.numero_commande}
                                                        </Link>
                                                    </td>
                                                    <td>{formatDate(cmd.date_commande)}</td>
                                                    <td className="text-end fw-bold text-primary">
                                                        {formatCurrency(cmd.montant_ttc)}
                                                    </td>
                                                    <td>{getStatutBadge(cmd.statut)}</td>
                                                    <td className="text-center">
                                                        <Button 
                                                            variant="outline-info" 
                                                            size="sm"
                                                            className="rounded-circle"
                                                            style={{ width: '32px', height: '32px', padding: 0 }}
                                                            onClick={() => navigate(`/achats/commandes/${cmd.id_commande_fournisseur}`)}
                                                        >
                                                            <i className="ri-eye-line"></i>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    )}

                    {/* Métadonnées */}
                    <Card className="border-0 shadow-sm mt-4" style={{ borderRadius: '16px', background: '#f8fafc' }}>
                        <Card.Body className="p-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="text-muted small">
                                    <i className="ri-information-line me-1"></i>
                                    ID: #{fournisseur.id_fournisseur} • 
                                    Créé le {formatDate(fournisseur.date_creation)}
                                    {fournisseur.date_modification && ` • Modifié le ${formatDate(fournisseur.date_modification)}`}
                                </div>
                                <div>
                                   <Button 
    variant="outline-danger" 
    size="sm"
    className="rounded-pill"
    onClick={() => setShowDeleteModal(true)}
>
    <i className="ri-delete-bin-line me-1"></i>
    Supprimer
</Button>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>


                {/* Modal de confirmation de suppression */}
<Modal 
    show={showDeleteModal} 
    onHide={() => setShowDeleteModal(false)} 
    centered 
    className="delete-modal"
>
    <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100">
            <div className="text-center">
                <div className="confirm-icon mb-3">
                    <div className="icon-wrapper bg-danger-soft">
                        <i className="ri-delete-bin-line text-danger"></i>
                    </div>
                </div>
                <h3 className="fw-bold text-danger">Supprimer le fournisseur</h3>
            </div>
        </Modal.Title>
    </Modal.Header>
    
    <Modal.Body className="text-center pt-2">
        <p className="text-muted mb-4">
            Êtes-vous sûr de vouloir supprimer <strong>{fournisseur?.raison_sociale}</strong> ?
        </p>
        
        <Alert variant="warning" className="text-start mb-4">
            <div className="d-flex">
                <i className="ri-alert-line fs-4 me-3 flex-shrink-0"></i>
                <div>
                    <strong>Cette action est irréversible</strong>
                    <p className="mb-0 small mt-1">
                        La suppression entraînera la perte définitive de toutes les informations 
                        liées à ce fournisseur. Les commandes existantes ne seront pas affectées.
                    </p>
                </div>
            </div>
        </Alert>

        <div className="bg-light p-3 rounded-3 mb-3">
            <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Code fournisseur :</span>
                <span className="fw-semibold">{fournisseur?.code_fournisseur}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Total commandes :</span>
                <span className="fw-semibold">{fournisseur?.nb_commandes || 0}</span>
            </div>
            <div className="d-flex justify-content-between">
                <span className="text-muted">Total achats :</span>
                <span className="fw-semibold text-primary">{formatCurrency(fournisseur?.total_achats || 0)}</span>
            </div>
        </div>
    </Modal.Body>
    
    <Modal.Footer className="border-0 pt-0 justify-content-center">
        <Button 
            variant="outline-secondary" 
            onClick={() => setShowDeleteModal(false)}
            className="px-4 rounded-pill"
            disabled={isDeleting}
        >
            <i className="ri-close-line me-2"></i>
            Annuler
        </Button>
        <Button 
            variant="danger" 
            onClick={handleDelete}
            className="px-5 rounded-pill"
            disabled={isDeleting}
            style={{
                background: 'linear-gradient(135deg, #dc3545, #bb2d3b)',
                border: 'none'
            }}
        >
            {isDeleting ? (
                <>
                    <Spinner size="sm" className="me-2" />
                    Suppression...
                </>
            ) : (
                <>
                    <i className="ri-delete-bin-line me-2"></i>
                    Supprimer
                </>
            )}
        </Button>
    </Modal.Footer>
</Modal>
<style>{`
    .delete-modal .modal-content {
        border: none;
        border-radius: 24px;
        box-shadow: 0 20px 40px rgba(0,0,0,0.2);
        overflow: hidden;
    }

    .delete-modal .modal-header {
        background: linear-gradient(135deg, #fff5f5, #ffffff);
        border-bottom: none;
        padding: 2rem 1.5rem 0.5rem;
    }

    .delete-modal .modal-body {
        padding: 1rem 2rem;
    }

    .delete-modal .modal-footer {
        border-top: 1px solid #e2e8f0;
        padding: 1.5rem 2rem 2rem;
        background: #f8fafc;
    }

    .icon-wrapper {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        font-size: 40px;
        animation: pulse 2s infinite;
    }

    .bg-danger-soft {
        background: rgba(220, 53, 69, 0.15);
    }

    .confirm-icon {
        animation: bounceIn 0.5s ease-out;
    }

    @keyframes bounceIn {
        0% { transform: scale(0); opacity: 0; }
        50% { transform: scale(1.1); }
        100% { transform: scale(1); opacity: 1; }
    }

    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.05); }
        100% { transform: scale(1); }
    }

    .delete-modal .btn {
        border-radius: 12px;
        font-weight: 600;
        padding: 0.6rem 1.5rem;
        transition: all 0.3s ease;
    }

    .delete-modal .btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(0,0,0,0.1);
    }

    .delete-modal .btn-outline-secondary:hover:not(:disabled) {
        background: #64748b;
        border-color: #64748b;
        color: white;
    }

    .delete-modal .alert {
        border: none;
        border-radius: 12px;
        background: linear-gradient(135deg, #fff3cd, #fff9e6);
        border-left: 4px solid #ffc107;
    }
`}</style>
                <style>{`
                    @keyframes slideIn {
                        from { opacity: 0; transform: translateX(-10px); }
                        to { opacity: 1; transform: translateX(0); }
                    }

                    .bg-gradient-primary {
                        background: linear-gradient(135deg, #4361ee, #3a56d4);
                        position: relative;
                        overflow: hidden;
                    }

                    .tracking-wide {
                        letter-spacing: 0.5px;
                    }

                    .list-group-item {
                        background: transparent;
                        border: none;
                        border-bottom: 1px solid #e2e8f0;
                        padding: 0.75rem 0;
                    }

                    .list-group-item:last-child {
                        border-bottom: none;
                    }

                    .card {
                        transition: all 0.3s ease;
                    }

                    .card:hover {
                        box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1) !important;
                    }
                `}</style>








                <Footer />
            </div>
        </>
    );
}